import * as angular from "angular";

const agreementTypes = [
  'Term',
  'Policy',
  'Consent'
];


angular
  .module('bringoz.admin.agreements')
  .constant('agreementConstants', {
    types : agreementTypes
  });
